'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import Actions from 'AdsUI/lib/Actions';
import AdProfileRecord from 'AdsUI/records/ad-accounts/AdProfileRecord';
export default ((state = new AdProfileRecord(), action) => {
  const {
    type,
    payload
  } = action;

  switch (type) {
    case Actions.AD_PROFILE_FETCH_SUCCEEDED:
      if (payload) {
        const {
          roiSetting
        } = payload,
              profile = _objectWithoutPropertiesLoose(payload, ["roiSetting"]);

        state = new AdProfileRecord(Object.assign({}, profile, {}, roiSetting));
      }

      break;

    default:
      break;
  }

  return state;
});